import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Measurement from './Timeline/Measurement'

const styles = {
  root: {
    marginRight: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  circle: {
    textAlign: 'center',
    borderRadius: '50%',
    background: '#8FB0E6',
    color: 'white',
    display: 'table-cell',
    verticalAlign: 'middle'
  },
  name: {
    textAlign: 'center',
    fontSize: '1rem',
    marginTop: 5,
    // maxWidth: 100
  },
  centered: {
    width: '100%',
    textAlign: 'center'
  },
  fixWidth: {
    width: 130,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}

class Datum extends Component {
  image() {
    const { datum } = this.props
    let symptomImage
    try {
      symptomImage = require(`../icons/symptoms/${datum.type.toLowerCase().split(' ').join('_')}.png`)
    } catch (e) {
      try {
        symptomImage = require(`../icons/symptoms/${datum.superType.toLowerCase().split(' ').join('_')}.png`)
      } catch (e) {
        symptomImage = require(`../icons/symptoms/undefined.png`)
      }
    }
    return symptomImage
  }

  symptomName (name) {
    switch (name) {
      case 'mouth_dryness':
        return 'mouth discomfort'
        break;
      case 'appetite_loss':
        return 'decreased appetite'
        break;
      case 'appetite':
        return 'decreased appetite'
        break;
      case 'mood':
        return 'sad'
        break;
      default:
        return name.toLowerCase().split('_').join(' ')
    }
  }

  renderName () {
    const { datum } = this.props
    if (datum.superType === 'medication') {
      return 'medication & supplement'
    }
    if (!datum.superType) return this.symptomName(datum.type)
    return (datum.type || datum.superType).toLowerCase().split('_').join(' ')
  }

  render () {
    const { classes, datum, size, styles, withMeasurements, fixWidth, margin, width } = this.props
    const imageWrapperStyles = fixWidth
      ? classes.fixWidth
      : ''

    const rootStyles = Object.assign({}, styles, {margin: margin})
    if (width) rootStyles.width = width

    return (
      <div className={classes.root} style={rootStyles}>
        <div className={imageWrapperStyles}>
          <div className={classes.centered}>
            <img src={this.image()} alt={datum.type} style={{width: size, height: 'auto' }} />
          </div>
          <div className={classes.name}>{this.renderName()}</div>
        </div>
        { withMeasurements && Object.keys(datum.measurements).map((measurementName, i) => <Measurement key={i} measurement={{name: measurementName, value: datum.measurements[measurementName]}}/>)}
      </div>
    )
  }
}

export default withStyles(styles)(Datum)



// WEBPACK FOOTER //
// ./src/components/Datum.js